module.exports = __webpack_public_path__ + "img/BBVA.5839baa8.svg";